const MinusSignIcon = /*#__PURE__*/ [
  ["path", { d: "M20 12L4 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { MinusSignIcon as default };
//# sourceMappingURL=MinusSignIcon.js.map
